import "./index.css";

import { BrowserRouter, Route, Routes } from "react-router";
import { WebsocketProvider } from "./lib/WebsocketProvider";
import { RootRoute } from "./routes";
import { RoomRoute } from "./routes/room";

export function App() {
  return (
    <WebsocketProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<RootRoute />}></Route>
          <Route path="/room/:id" element={<RoomRoute />}></Route>
        </Routes>
      </BrowserRouter>
    </WebsocketProvider>
  );
}

export default App;
